import { getDeferred } from './resource';

export function getCurrencies() {
    return {
        GBP: getDeferred('GBP'),
        GIP: getDeferred('GIP'),
        EUR: getDeferred('EUR'),
        USD: getDeferred('USD'),
        INR: getDeferred('INR'),
        AED: getDeferred('AED'),
        SAR: getDeferred('SAR'),
        OMR: getDeferred('OMR'),
        BHD: getDeferred('BHD'),
        QAR: getDeferred('QAR'),
        KWD: getDeferred('KWD'),
        JOD: getDeferred('JOD'),
        EGP: getDeferred('EGP'),
        ZAR: getDeferred('ZAR'),
        RUB: getDeferred('RUB'),
        SEK: getDeferred('SEK'),
        DKK: getDeferred('DKK'),
        XOF: getDeferred('XOF'),
        THB: getDeferred('THB'),
        HKD: getDeferred('HKD'),
        SGD: getDeferred('SGD'),
        MYR: getDeferred('MYR'),
        CAD: getDeferred('CAD'),
        AUD: getDeferred('AUD')
    };
}

export function getSymbol(code) {
    const currencies = getCurrencies();
    return currencies[code] && currencies[code]();
}
